module.exports = __webpack_public_path__ + "img/agency_mhtong.46c78b6e.png";